import { CouponApi } from '@linktivity/triplabo-taxi';

import config from '../config';

const coupon = new CouponApi(config);

export default coupon;
